module.exports = __webpack_public_path__ + "static/media/2.1a05002c.jpg";